import styled from 'styled-components';
import { useViewedVehicle } from '../../hooks/useViewedVehicle';
import { InfoBlock } from '../InfoBlock';

const Wrapper = styled.div`
  display: flex;
  padding: 32px 120px 24px 32px;
  flex-direction: column;
  gap: 14px;
  height: 100%;

  @media (max-width: 1024px) {
    gap: 12px;
    padding: 16px;
  }
`;

const MainContent = styled.div`
  display: flex;
  gap: 16px;
`;

const TextInfo = styled.div`
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
  height: 100%;
  font-weight: 400;
  line-height: 20px;
  color: rgba(97, 97, 97, 1);

  @media (max-width: 1024px) {
    font-size: 12px;
    line-height: 16px;
  }
`;

const Title = styled.div`
  display: flex;
  gap: 14px;
  font-size: 16px;
  font-weight: 600;
  line-height: 18.75px;

  @media (max-width: 1024px) {
    font-size: 14px;
    line-height: 16.41px;
  }
`;

export const InspectorComments = () => {
  const vehicle = useViewedVehicle();
  if (!vehicle || !vehicle.inspector_notes?.message) return null;

  return (
    <InfoBlock>
      <Wrapper>
        <Title>Inspector Comments</Title>
        <MainContent>
          <TextInfo>{vehicle.inspector_notes.message}</TextInfo>
        </MainContent>
      </Wrapper>
    </InfoBlock>
  );
};
